import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Activity, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './SafePulseHomeSection.css';
import SafePulseImage from './safepulse-1.png';

const SafePulseHomeSection = () => {
  const navigate = useNavigate();

  return (
    <section className="sp-home-section">
      <div className="sp-home-container">
        <div className="sp-home-content">
          <motion.div 
            className="sp-home-label-wrapper"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="sp-home-label">SafePulse</span>
          </motion.div>
          
          <motion.h2 
            className="sp-home-headline"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Your Digital DNA. <br />
            <span className="sp-gradient-text">Impossible to Steal.</span>
          </motion.h2>
          
          <motion.p 
            className="sp-home-description"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Experience continuous, invisible authentication. SafePulse analyzes your unique typing rhythms and mouse movements to create a behavioral biometric profile that protects you every second.
          </motion.p>
          
          <div className="sp-feature-pills">
            <div className="sp-pill">
                <Activity size={18} />
                <span>Zero Friction</span>
            </div>
            <div className="sp-pill">
                <Lock size={18} />
                <span>Local Privacy</span>
            </div>
            <div className="sp-pill">
                <ShieldCheck size={18} />
                <span>Real-Time Defense</span>
            </div>
          </div>

          <motion.button 
            onClick={() => navigate('/safepulse')}
            className="sp-home-link"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            Discover SafePulse <ArrowRight className="sp-link-arrow" />
          </motion.button>
        </div>

        <motion.div 
          className="sp-home-image-wrapper"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <div className="sp-glow-effect"></div>
          <img src={SafePulseImage} alt="SafePulse Technology" className="sp-home-image" />
        </motion.div>
      </div>
    </section>
  );
};

export default SafePulseHomeSection;
